import { render, staticRenderFns } from "./editDemand.vue?vue&type=template&id=87e340e0&scoped=true&"
import script from "./editDemand.vue?vue&type=script&lang=js&"
export * from "./editDemand.vue?vue&type=script&lang=js&"
import style0 from "./editDemand.vue?vue&type=style&index=0&id=87e340e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e340e0",
  null
  
)

export default component.exports